import * as Yup from 'yup';

import { validUSState } from 'common/helpers/yup-helpers';

Yup.addMethod(Yup.mixed, 'validUSState', validUSState);

// `requireAppliesToStructure` is set for farm offers/policies, where each mortgage must be tied to a
// specific structure. The field is only rendered when structure options exist, so making it required
// unconditionally would block non-farm mortgage adds (auto/home) where the field never appears. (#32664)
export const mortgageValidationSchema = ({ inOfferEditRoute, requireAppliesToStructure = false }) =>
  Yup.object().shape({
    ...(requireAppliesToStructure && {
      appliesToStructure: Yup.string().trim().required('Please select the structure this mortgage applies to')
    }),
    loanNumber: Yup.string()
      .test('requiredForPolicy', function (value) {
        if (inOfferEditRoute) {
          // loanNumber is not required in offer edit route, will be required later when continuing to checkout
          return true;
        }
        return value?.trim()?.length > 0 ? true : this.createError({ message: 'Loan number is required' });
      }),
    mortgageHolderName: Yup.string()
      .test('mortgageHolderName', function (value) {
        if (value) {
          return true;
        }
        return this.createError({ message: 'Lender is required' });
      }),
    mortgageHolderAddress: Yup.object().shape({
      address: Yup.string().required('Address is required'),
      address2: Yup.string().nullable(),
      city: Yup.string().required('City is required'),
      state: Yup.string().validUSState('offer.mortgageHolderAddress.state').required('State is required'),
      zip: Yup.string().required('Zip code is required')
    })
  });
